/**
 * Was auf jeder Seite gebraucht wird. Alles andere gehört in den
 * {% javascript %}-Block der jeweiligen Section.
 *
 * Grundsatz: so wenig wie möglich. Eine Seite, die auf JavaScript wartet,
 * fühlt sich nicht teuer an.
 */

(() => {
  'use strict';

  /**
   * Elemente mit der Klasse `rein` blenden einmalig ein, sobald sie in Sicht
   * kommen. Bei reduzierter Bewegung passiert nichts — das CSS hat sie dann
   * schon sichtbar gestellt.
   */
  const einblenden = () => {
    const ziele = document.querySelectorAll('.rein:not(.rein--da)');
    if (!ziele.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ziele.forEach((el) => el.classList.add('rein--da'));
      return;
    }

    const beobachter = new IntersectionObserver(
      (eintraege) => {
        for (const eintrag of eintraege) {
          if (!eintrag.isIntersecting) continue;
          eintrag.target.classList.add('rein--da');
          beobachter.unobserve(eintrag.target);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    ziele.forEach((el) => beobachter.observe(el));
  };

  einblenden();

  // Der Theme-Editor tauscht Sections aus, ohne die Seite neu zu laden.
  document.addEventListener('shopify:section:load', einblenden);
})();
